module.exports = __webpack_public_path__ + "static/media/caret.bf829718.svg";